import React, { useMemo } from 'react';
import Header from '../components/Header';
import PersonalDataInput from '../components/PersonalDataInput';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getExcursion, getAvailability, bookingRequest } from '../api/api';
import moment from 'moment';
import 'moment/locale/it';
import 'moment/locale/en-gb';
import 'moment/locale/fr';
import 'moment/locale/de';
import { strings } from '../localization/strings';

function PersonalData() {
  const location = useLocation();
  const navigate = useNavigate();

  function useQuery() {
    return new URLSearchParams(location.search);
  }

  const query = useQuery();
  const excursionId = query.get('tourid');
  const language = query.get('lang') ?? 'it';
  let date = query.get('dateFormat');
  //date = moment(date, 'YYYY-MM-DD');
  moment.locale(language);
  const translation = strings[language] ?? strings.it;
  
  const uiDate = moment(date).format('DD MMM YYYY');
  let adult = query.get('tour-adult') ?? 0;
  let child = query.get('tour-children') ?? 0;
  let baby = query.get('tour-infant') ?? 0;
  if (adult === '') { adult = 0; }
  if (child === '') { child = 0; }
  if (baby === '') { baby = 0; }
  const passengers = parseInt(adult) + parseInt(child) + parseInt(baby);

  const state = useMemo(() => location.state || {
    inputs: {
      adult,
      child,
      baby,
      passengers,
      date,
      excursionId,
      uiDate
    }
  }, [location.state, adult, child, baby, passengers, date, excursionId, uiDate]);

  const [excursion, setExcursion] = useState(null);
  const [availability, setAvailability] = useState(null);

  useEffect(() => {
    async function fetchExcursion() {
      try {
        getExcursion(excursionId).then(response => {
          setExcursion(response.data);
          state.excursion = response.data;
          state.excursionName = language === 'it' ? response.data.name : response.data.nameMulti[language];
          if (response.data.homepage) {
            state.excursionUrl = response.data.baseUrl + (language === 'it' ? response.data.homepage : response.data.homepageMulti[language]);
          }
          getAvailability(excursionId, date, passengers).then(response => {
            if (!response.data || response.data.availableText === undefined || response.data.availableText === 2) {
              if (state.excursionUrl) {
                window.location.href = state.excursionUrl;
              } else {
                window.location.href = "https://booking.egadiescursioni.it/"
              }
            }
            setAvailability(response.data);
            state.availability = response.data;
          });
        }).catch(() => {
          window.location.href = "https://booking.egadiescursioni.it/"
        });
        
      } catch (error) {
        console.error('Error fetching the excursion data', error);
      }
    }

    if (excursionId && !excursion) {
      fetchExcursion();
    }
  }, [excursionId, date, passengers, state]);

  function nextStep(formData, invoiceData) {
    state.formData = formData;
    state.invoiceData = invoiceData;
    const reservation = buildReservationObject(formData, invoiceData);
    bookingRequest(reservation).then(response => {
      state.bookingRequestId = response.data.id;
      state.bookingTransactionId = response.data.transactionId;
      navigate('/payment-data' + location.search, { state: state });
    }, error => {
      console.error('Error creating the reservation', error);
    });
  }

  function buildReservationObject(formData, invoiceData) {
    let notes =
      'Prenotazione Booking';
    if (formData.length > 1 || (formData.length === 1 && formData[0].birthday)) {
      for (let i = 0; i < formData.length; i++) {
        notes +=
          '<br>Viaggiatore ' +
          (i + 1) +
          ': ' +
          formData[i].first_name +
          ' ' +
          formData[i].last_name;
        notes += '<br>Data di nascita: ' + formData[i].birthday;
        if (formData[i].additional_notes) {
          notes +=
            '<br>Richiesta speciale: ' + formData[i].additional_notes;
        }
      }
    } else if (formData.length === 1) {
      if (formData[0].additional_notes) {
        notes +=
          '<br>Richiesta speciale: ' + formData[0].additional_notes;
      }
    }
    
    if (invoiceData.invoiceRequest) {
      notes += '<br>Richiesta fattura';
      notes += '<br>Ragione sociale: ' + invoiceData.ragioneSociale;
      notes += '<br>Partita IVA: ' + invoiceData.partitaIva;
      if (invoiceData.country !== 'Italia') {
        notes +=
          '<br>Indirizzo completo: ' +
          invoiceData.codiceFiscale + // address
          ' ' +
          invoiceData.sedeLegale + // city
          ' ' +
          invoiceData.codiceDestinatario; // country (in eng)
      } else {
        notes += '<br>Codice fiscale: ' + invoiceData.codiceFiscale;
        notes += '<br>Sede legale: ' + invoiceData.sedeLegale;
        notes +=
          '<br>Codice destinatario: ' +
          invoiceData.codiceDestinatario;
      }
    }

    const newReservation = {
      type: 0,
      state: {
        value: 0
      },
      client: {
        name: 'OL ' +
        formData[0].first_name,
        surname: formData[0].last_name,
        phone: formData[0].phone,
        email: formData[0].email,
        language: language ?? 'it'
      },
      tour: {
        go: {
          date: date,
          selection: {
            selected: excursion._id,
            name: excursion.name,
            nameMulti: excursion.nameMulti
          }
        },
        adult: adult,
        reduced: child,
        free: baby
      },
      payment: {
        state: {
          value: 2
        },
        balance: {
          date: moment().format('YYYY-MM-DD'),
          amount: 0,
          payment: 5 // Online
        }
      },
      note: notes
    };

    return newReservation;
  }

  return (
    <div className="tourmaster-page-wrapper tourmaster-payment-style-1 tourmaster-template-payment" id="tourmaster-page-wrapper">
        <Header currentStep="2" tourName={state?.excursionName} language={language} tourUrl={state?.excursionUrl}/>
        <div className="tourmaster-template-wrapper" id="tourmaster-payment-template-wrapper">
          <div className="tourmaster-container">
            <div className="tourmaster-page-content tourmaster-item-pdlr clearfix">
              <PersonalDataInput nextStep={nextStep} availability={availability} tourName={state?.excursionName} requestAllDetails={state?.excursion?.allPassengersDetails} date={uiDate} adult={adult} child={child} baby={baby} language={language} excludeFree={state?.excursion?.excludeFree}/>
            </div>
          </div>
        </div>
    </div>
  );
}

export default PersonalData;